import {
  alertMessagesArgsConfig,
  browserStorageArgsConfig,
  consoleLogArgsConfig,
  onlyRedirectArgsConfig,
  userRoleArgsConfig,
} from '../utils/event_constants';

export const externalApiActions = [
  {
    name: 'sendDataToExternalApi',
    label: 'Send Data To External API',
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsExternalApi',
        value: '',
      },
      {
        name: 'sessionValue',
        label: 'Send Session Response Value (comma separated)',
        type: 'text',
        value: '',
      },
      {
        name: 'sessionFormValue',
        label: 'Send Session Form Value (comma separated)',
        type: 'text',
        value: '',
      },
      ...browserStorageArgsConfig,
      {
        label: 'Save Full API Response',
        name: 'saveCompleteAPIResponse',
        type: 'boolean',
        value: '',
      },
      ...alertMessagesArgsConfig,
      {
        name: 'overrideBrowserSessionValuesKey',
        label: 'Override Each Record JSON Key',
        type: 'boolean',
        value: '',
      },
      {
        name: 'overrideBrowserSessionFormDataValuesKey',
        label: 'Override Each Record JSON Key',
        type: 'boolean',
        value: '',
      },
      {
        name: 'overrideResponseDataKey',
        label: 'Save API Response In Custom JSON Key',
        type: 'boolean',
        value: '',
      },
      {
        name: 'overrideFormDataKey',
        label: 'Save API Response In Custom JSON Key',
        type: 'boolean',
        value: '',
      },
      {
        name: 'overriddenCustomJsonKey',
        label: 'Custom JSON Key',
        type: 'text',
        value: '',
      },
      {
        name: 'overriddenFormCustomJsonKey',
        label: 'Custom JSON Key',
        type: 'text',
        value: '',
      },
      {
        name: 'sendPreviousActionResponseItemId',
        label: 'Send Item Id of previous action response',
        type: 'boolean',
        value: '',
      },
      ...consoleLogArgsConfig,
    ],
  },
  {
    name: 'sendDataToExternalApiAndAuthorize',
    label: 'Authorize Using External API',
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsExternalApi',
        value: '',
      },
      userRoleArgsConfig({}),
      {
        name: 'sessionValue',
        label: 'Send Session Value (comma separated)',
        type: 'text',
        value: '',
      },
      onlyRedirectArgsConfig,
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save API Response In Browser Session',
        type: 'boolean',
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Session Form Data',
        type: 'boolean',
        value: '',
      },
    ],
  },
  {
    name: 'sendDataToExternalApiAndFileDownload',
    label: 'Download File Using External API',
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsExternalApi',
        value: '',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save API Response In Browser Session',
        type: 'boolean',
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Session Form Data',
        type: 'boolean',
        value: '',
      },
    ],
  },
  {
    name: 'triggerZap',
    label: 'Zapier - Trigger a Zap',
    args: [
      {
        name: 'webhookId',
        label: 'Zaps',
        type: 'dropdown',
        optionsType: 'dsZaps',
        value: '',
      },
      {
        name: 'sessionValue',
        label: 'Send Session Value (comma separated)',
        type: 'text',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save API Response In Browser Session',
        type: 'boolean',
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Session Form Data',
        type: 'boolean',
        value: '',
      },
    ],
  },
];
